/**
 * 로그인 실패 시 뜨는 안내 모달. `message` prop 이 없으면 기본 문구(아이디·비밀번호 재확인 안내)를 쓴다.
 * `BaseDialog` 위에 확인 버튼만 얹은 형태라 ESC·배경 클릭·포커스 트랩은 BaseDialog 가 처리한다.
 */
import React from "react";
import Fail from "../icons/login/Fail";
import BaseDialog from "./BaseDialog";

interface ModalProps {
  onClose: () => void;
  isOpen: boolean;
  message?: string;
}

const LoginFailModal: React.FC<ModalProps> = ({
  onClose,
  isOpen,
  message,
}) => {
  return (
    <BaseDialog
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="로그인 실패"
      widthClassName="w-[360px] max-w-[calc(100vw-32px)]"
      containerClassName="bg-white pt-[36px] px-[20px] pb-[20px] rounded-[12px] flex flex-col justify-between"
    >
      {/* 버튼 위 */}
      <div className="flex flex-col items-center gap-y-[12px]">
        <Fail />
        <span className="text-18 text-heading font-bold text-center font-heading">
          로그인 실패
        </span>
        <span className="text-15 text-body text-center">
          {message ? (
            message
          ) : (
            <>
              올바른 아이디 또는 비밀번호가 아닙니다. <br />
              아이디와 비밀번호를 다시 확인해주세요.
            </>
          )}
        </span>
      </div>

      <div className="mt-[10px] pt-[20px]">
        <button
          type="button"
          onClick={onClose}
          data-autofocus
          className="blue-button w-full h-[47px] focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:outline-none"
        >
          확인
        </button>
      </div>
    </BaseDialog>
  );
};

export default LoginFailModal;
